

import {
    Component,
    OnInit,
  } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { arrayUnion, updateDoc } from "firebase/firestore";
import { deleteObject, getStorage, listAll, ref } from "firebase/storage";
  import { NGXLogger } from "ngx-logger";
  import { MenuItem, MessageService } from "primeng/api";
  
  import {
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";
  import { Subject } from "rxjs";
import { PreventivoFase1DTO } from "src/app/models/dto/preventivoFase1.model";
import { SopralluogoFase1DTO } from "src/app/models/dto/sopralluogoFase1.model";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { GoogleStorageService } from "src/app/services/googleStorage.service";
import { PraticheScuolaService } from "src/app/services/pratiche.scuola.service";
import { PraticheService } from "src/app/services/pratiche.service";
import { environment } from "src/environments/environment";

  

@Component({
    selector: "app-carica-foto-fase2",
    templateUrl: "./dialog-carica_foto.component.html",
    styleUrls: ["../shared.component.css"],
  })
  export class DialogCaricaFoto implements OnInit {
    protected _onDestroy = new Subject<void>();
    protected pratica: PraticaFlowdy2_Firestore;
    protected tipoFile:String="";
    
    protected file: File;
    protected files: File[]=[];
    protected isUploadingFile:boolean = false;
    
    protected label:string="Cerca file ";
    protected icona:string="";
    protected stile:string="btn-choose-file-fase2";
    protected fileClass:string="btn-choose-file-fase2";
    protected acceptedFileTypes:string=".jpg, .png, .jpeg, .tiff, .gif, .pdf, .PDF";
    protected numeroFotoCPE:number = 0;
    protected existingFilesMessage:string="ATTENZIONE! La pratica contiene già ";
    protected isCpeWithFoto:boolean = false;
    private collection_pratiche:string = environment.firebase.collection_pratiche;


    constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private googleStorageService: GoogleStorageService,
      private messageService: MessageService,
      private formBuilder: FormBuilder,
      public firestore: AngularFirestore,
    ) {
      this.pratica          = this.config.data.pratica;
      this.tipoFile         = this.config.data.tipoFile;
      if(this.tipoFile==='PING TEST'){
        this.label+=this.tipoFile  ;
      }else if(this.tipoFile==='SPEED TEST'){
        this.label+=this.tipoFile  ;
      }else if(this.tipoFile==='FOTO ROUTER'){
        this.label+=this.tipoFile  ;
      }else if(this.tipoFile==='CPE'){
        this.logger.info( this.pratica.numeroFotoCPEUploaded);
        this.existingFilesMessage +=this.pratica.numeroFotoCPEUploaded;
        if(this.pratica.numeroFotoCPEUploaded==1){
          this.existingFilesMessage +=" foto del CPE caricata. Se si prosegue, questa verrà eliminata";
        }else{
          this.existingFilesMessage +=" foto del CPE caricate. Se si prosegue, queste verranno eliminate";
        }
         
        
      }
      
      
    }
  
    ngOnInit(): void {
    }

    onFileUpload($event){

    }

    onFileSelect($event: { files: File[]; }) {
        if($event.files.length == 1){
          if(this.tipoFile==='FOTO ROUTER'){
            this.label = 'Foto del ROUTER caricata';
          }else{
            this.label = 'Foto del CPE caricata';
          }
          
        }else{
          this.label = $event.files.length + ' foto del CPE caricate';
        }
        
     
      this.icona = "pi pi-check";
      this.fileClass = "btn-file-fase2-upload-success";
      this.file = $event.files[0];
      this.files = Array.from($event.files); // oppure [...this.files]
     
    }  

    async checkIfFileAlreadyUploaded(tipoFile:string){
          const storage = getStorage();
          const pathReferenceFileFase2    = ref(  storage, "pratiche/scuola/" +  this.pratica.cui + "/IN/FASE_2/foto/" );
          try {
            const listResultFileFase2 = await listAll(pathReferenceFileFase2);
        
            if (listResultFileFase2.items.length > 0) {
              const deletePromises: Promise<void>[] = [];
        
              for (const item of listResultFileFase2.items) {
                if (item.name.includes(tipoFile)) {
                  this.logger.info(`FILE ${tipoFile} GIA' PRESENTE: ${item.name}, eliminazione in corso...`);
                  const fileRef = ref(storage, item.fullPath);
                  deletePromises.push(deleteObject(fileRef));
                }
              }
        
              await Promise.all(deletePromises);
              this.logger.info(`Tutti i file con tipo '${tipoFile}' sono stati eliminati.`);
            } else {
              this.logger.info("Nessun file trovato per la rimozione.");
            }
          } catch (error) {
            this.logger.error("Errore durante la verifica e l'eliminazione dei file:", error);
          }
          
        }

   
    conferma(conferma: boolean) {
      if (!conferma) {
        this.dialogRef.close({ success: false });
      } else {

          this.isUploadingFile = true;
          if(this.tipoFile!=='FOTO ROUTER'){
            let contatoreFile:number = 0;
            const fileDeletePromises: Promise<any>[] = [];

            fileDeletePromises.push(this.checkIfFileAlreadyUploaded("CPE")); 
             
           /*  if(this.pratica.numeroFotoCPEUploaded && this.pratica.numeroFotoCPEUploaded > 0){
              contatoreFile = this.pratica.numeroFotoCPEUploaded ;
            } */
              Promise.all(fileDeletePromises).then(results => {
                const fileUploadPromises: Promise<any>[] = [];

            for (let index = 0; index < this.files.length; index++) {
              contatoreFile+=1;
              const file = this.files[index];
              const fileExtension = file.name.substring( file.name.lastIndexOf(".") + 1 );
              let fileName        = this.pratica.cui + "/IN/FASE_2/foto/";
              fileName += "CPE_"+contatoreFile+"."+fileExtension;
              
              
              const fileUploadPromise = this.googleStorageService.uploadFileScuolaToGoogleStorage(file, fileName);

              fileUploadPromises.push(fileUploadPromise);
              
            }
          
            Promise.all(fileUploadPromises).then(results => {
              const docRef = this.firestore.collection(this.collection_pratiche).doc(this.pratica.cui);
              this.pratica.fotoCPEUploaded = true;
              this.pratica.numeroFotoCPEUploaded = contatoreFile;
              
              docRef.update(this.pratica)
                .then(() => {
                  
                  this.isUploadingFile = false;
                  this.dialogRef.close({ success: true});
                })
                .catch((error) => {
                  this.messageService.add({
                    severity: "info",
                    summary: "Errore" , life:10000,
                      detail: "Errore in fase di caricamento della foto del CPE!",
                    });
                  
                  this.dialogRef.close({ success: false });
                });
            }).catch(error => {
              this.dialogRef.close({ success: false });
            }).finally(() => {
              this.isUploadingFile = false;
            });
              });
          
            
          }else{
            const fileUploadPromises: Promise<any>[] = [];

            for (let index = 0; index < this.files.length; index++) {
              const file = this.files[index];
              const fileExtension = file.name.substring( file.name.lastIndexOf(".") + 1 );
              let fileName        = this.pratica.cui + "/IN/FASE_3/foto/router."+fileExtension;
              
              
              const fileUploadPromise = this.googleStorageService.uploadFileScuolaToGoogleStorage(this.file, fileName);

              fileUploadPromises.push(fileUploadPromise);
              
            }
          
            Promise.all(fileUploadPromises).then(results => {
              const docRef = this.firestore.collection(this.collection_pratiche).doc(this.pratica.cui);
              this.pratica.fotoRouterUploaded = true;
              
              docRef.update(this.pratica)
                .then(() => {
                  
                  this.isUploadingFile = false;
                  this.dialogRef.close({ success: true});
                })
                .catch((error) => {
                  this.messageService.add({
                    severity: "info",
                    summary: "Errore" , life:10000,
                      detail: "Errore in fase di caricamento della foto del Router!",
                    });
                  
                  this.dialogRef.close({ success: false });
                });
            }).catch(error => {
              this.dialogRef.close({ success: false });
            }).finally(() => {
              this.isUploadingFile = false;
            });
          }
          
         
       
      } 
    }
  
  }